/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Sync_Same_Group_ErrorInputs */



/**
* | output |
* | --- |
* | "Choose two different Event Groups." |
*
* @param {Event_Group_Sync_Same_Group_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_sync_same_group_error = /** @type {((inputs?: Event_Group_Sync_Same_Group_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Sync_Same_Group_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Choose two different Event Groups.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Choose two different Event Groups.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Choose two different Event Groups.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Choose two different Event Groups.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Choose two different Event Groups.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Choose two different Event Groups.")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Choose two different Event Groups.")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Choose two different Event Groups.")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Choose two different Event Groups.")
	return /** @type {LocalizedString} */ ("Choose two different Event Groups.")
});